import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ECACReportService from '_services/ecac-report-service';

export const fetchECACReport = createAsyncThunk(
  'ecacReport/fetch',
  async (params, { signal }) => {
    return await ECACReportService.getECACReport(params, signal);
  }
);

export const patchBooking = createAsyncThunk(
  'ecacReport/patchBooking',
  async ({ bookingId, patch }) => {
    await ECACReportService.patchBooking(bookingId, patch);
    return { bookingId, patch };
  }
);

const initialState = {
  data: null,
  status: 'idle',
  error: null,
  patchStatus: 'idle',
  patchError: null,
};

const ecacReportSlice = createSlice({
  name: 'ecacReport',
  initialState,
  reducers: {
    resetECACReport: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
    },
    resetPatchBookingStatus: (state) => {
      state.patchStatus = 'idle';
      state.patchError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchECACReport.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchECACReport.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchECACReport.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(patchBooking.pending, (state) => {
        state.patchStatus = 'loading';
        state.patchError = null;
      })
      .addCase(patchBooking.fulfilled, (state) => {
        state.patchStatus = 'succeeded';
        state.patchError = null;
      })
      .addCase(patchBooking.rejected, (state, action) => {
        state.patchStatus = 'failed';
        state.patchError = action.error.message;
      });
  },
});

export const selectECACReportData = (state) => state.ecacReport.data;
export const selectECACReportStatus = (state) => state.ecacReport.status;
export const selectECACReportError = (state) => state.ecacReport.error;
export const selectPatchBookingStatus = (state) => state.ecacReport.patchStatus;
export const selectPatchBookingError = (state) => state.ecacReport.patchError;

export const { resetECACReport, resetPatchBookingStatus } = ecacReportSlice.actions;

export default ecacReportSlice.reducer;
